// extracted by mini-css-extract-plugin
export default {"menuMapBtn":"HomeMenuFullBtn_menuMapBtn__7qQNP","menuMapDescriptionSec":"HomeMenuFullBtn_menuMapDescriptionSec__v2V8c","mapIcon":"HomeMenuFullBtn_mapIcon__zDD6O"};